import { TableRowActionsButton } from '@shared/ui/table/row-actions';

import { Table } from './table';
import { TableSort, TableSortHeader } from './sort';
import {
  TableRow,
  TableRowDef,
  TableFooterRow,
  TableHeaderRow,
  TableNoDataRow,
  TableFooterRowDef,
  TableHeaderRowDef,
} from './row';
import {
  TableCell,
  TableCellDef,
  TableColumnDef,
  TableFooterCell,
  TableHeaderCell,
  TableFooterCellDef,
  TableHeaderCellDef,
} from './cell';

export { Table } from './table';
export {
  TableCell,
  TableCellDef,
  TableColumnDef,
  TableFooterCell,
  TableHeaderCell,
  TableFooterCellDef,
  TableHeaderCellDef,
} from './cell';
export {
  TableRow,
  TableRowDef,
  TableFooterRow,
  TableHeaderRow,
  TableNoDataRow,
  TableFooterRowDef,
  TableHeaderRowDef,
} from './row';
export { TableSort, TableSortHeader, type TableSortEvent, type TableSortable, type TableSortDirection } from './sort';
export { ACTIONS_COLUMN, TableRowActionsButton } from './row-actions';

/** Core table directives — always needed to render a table. Spread into a component's `imports`. */
export const TABLE_IMPORTS = [
  Table,
  TableCell,
  TableCellDef,
  TableColumnDef,
  TableFooterCell,
  TableHeaderCell,
  TableFooterCellDef,
  TableHeaderCellDef,
  TableRow,
  TableRowDef,
  TableFooterRow,
  TableHeaderRow,
  TableNoDataRow,
  TableFooterRowDef,
  TableHeaderRowDef,
  TableRowActionsButton,
] as const;

/** Optional sorting directives — spread alongside TABLE_IMPORTS when the table is sortable. */
export const TABLE_SORT_IMPORTS = [TableSort, TableSortHeader] as const;
